import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Chip } from '../../../../../../../components/design-system';
import useProductSearch from '../hook';
import Categories from './Categories';
import Locations from './Locations';
import Products from './Products';

interface Props {
  q: string;
  onChangeQ: (q: string) => void;
  onSelectSuggestion?: () => void;
}

export default function SearchResult({
  q,
  onChangeQ,
  onSelectSuggestion,
}: Props) {
  const t = useTranslations('shop');
  const [selected, setSelected] = useState('all');
  const { data: suggestions, isError, isLoading } = useProductSearch({ q });

  if (!suggestions) {
    return null;
  }

  const hasSuggestions = Object.values(suggestions || {}).some(
    (value) => value.count > 0,
  );
  return (
    <div className="tw-p-4 tw-space-y-2">
      <div className="tw-flex tw-gap-2">
        {hasSuggestions && (
          <Chip active={selected === 'all'} onClick={() => setSelected('all')}>
            {t('search.all')}
          </Chip>
        )}
        {suggestions.products.count > 0 && (
          <Chip
            active={selected === 'products'}
            onClick={() => setSelected('products')}
          >
            {t('search.products')}
          </Chip>
        )}
        {(suggestions.categories.count > 0 ||
          suggestions.subcategories.count > 0) && (
          <Chip
            active={selected === 'categories'}
            onClick={() => setSelected('categories')}
          >
            {t('search.categories')}
          </Chip>
        )}
        {(suggestions.countries.count > 0 || suggestions.regions.count > 0) && (
          <Chip
            active={selected === 'locations'}
            onClick={() => setSelected('locations')}
          >
            {t('search.locations')}
          </Chip>
        )}
      </div>
      {['all', 'products'].includes(selected) && (
        <Products q={q} suggestions={suggestions} />
      )}
      {['all', 'categories'].includes(selected) && (
        <Categories suggestions={suggestions} onClick={onSelectSuggestion} />
      )}
      {['all', 'locations'].includes(selected) && (
        <Locations suggestions={suggestions} onClick={onSelectSuggestion} />
      )}
    </div>
  );
}
